import React, { useEffect } from "react";
import t from "../../../utils/common/translation/translator";
import BomSection from "./BomSection";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../store/slices/common";
import { useQuery } from "react-query";
import { getProductsDescriptions } from "../../../utils/common/api/api";

const BillOfMaterials = ({ productsList }) => {
  const locale = useSelector(selectLocale);
  const [products, setProducts] = useState(productsList);

  const updateProductDescription = (product, descriptions, locale) => {
    // console.log("updateProductDescription", product, descriptions, locale);
    const translatedDescriptionObject = descriptions.find(
      (desc) => desc.catalogue_product.id === product.commercialReference
    )?.catalogue_product?.long_desc?.translation;
    return translatedDescriptionObject?.[locale] || translatedDescriptionObject?.["en-GB"] || product.mediumDescription;
  };

  const { refetch: execGetProductsDescriptions } = useQuery(
    "GET PRODUCTS DESCRIPTIONS : it's a Post method",
    async () => {
      try {
        const fetchedDescriptions = await getProductsDescriptions(
          productsList.map((product) => product.commercialReference)
        );
        return fetchedDescriptions;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false,
      onSuccess: (descriptions) => {
        // set  descriptions for eeqch product
        const updatedProducts = productsList.map((product) => ({
          ...product,
          translatedDescription: updateProductDescription(product, descriptions, locale)
        }));
        setProducts(updatedProducts);
      }
    }
  );

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      execGetProductsDescriptions();
    }
  }, []);

  return (
    <>
      <BomSection
        title={t("mc12.ui.step.finalize.title.track")}
        products={products?.filter((product) => product.step === "BuildTrack")}
      />

      <BomSection
        title={t("mc12.ui.steper.elecrical_installation")}
        products={products?.filter((product) => product.step === "ElectricalInstallation")}
      />
      <BomSection
        title={t("mc12.ui.steper.communication")}
        products={products?.filter((product) => product.step === "Communication")}
      />

      <BomSection
        title={t("mc12.ui.steper.accessories")}
        products={products?.filter((product) => product.step === "Accessories")}
      />
    </>
  );
};

export default BillOfMaterials;
